/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChildren } from 'preact';

import { MenuValueUpdateDetail } from './menuUtils';
import { SelectMenuGroupContext } from './SelectMenuGroupContext';

type SelectMultipleMenuGroupProps = {
  children: ComponentChildren;
  value?: string[];
  onCommit?: (detail: MenuValueUpdateDetail<string[]>) => void;
  groupKey?: string;
};

export function SelectMultipleMenuGroup({
  value,
  onCommit,
  children,
  groupKey
}: SelectMultipleMenuGroupProps) {
  return (
    <SelectMenuGroupContext.Provider value={{ isMultiple: true, value, onCommit, groupKey }}>
      {children}
    </SelectMenuGroupContext.Provider>
  );
}
